import { useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import toast from 'react-hot-toast'
import Modal from '../../../components/common/Modal'
import { api, apiHeaders } from '../../../configs/api'
import { useAuth } from '../../../context/AuthContext'
import { ProfessionalDetailType, useProfessional } from '../../../context/ProfessionalContext'

const ProfessionalDeactivate = ({
    open,
    handleClose,
    data
}: {
    open: boolean
    handleClose: () => void
    data: ProfessionalDetailType | null
}) => {
    const { unity, token, user, loadUsers } = useAuth()
    const { loadProfessionals } = useProfessional()
    const form = useForm()
    const formRef = useRef<HTMLFormElement>(null)
    const navigate = useNavigate()

    const handleDeactivate = async () => {
        if (!data || !unity || !token) return

        try {
            const response = await fetch(`${api}professional/delete`, {
                method: 'POST',
                headers: apiHeaders(token),
                body: JSON.stringify({ id: data.professional.id, unityID: unity.unityID })
            })
            const result = await response.json()
            if (!response.ok || !result.success) throw new Error(result.message)

            await loadProfessionals()
            await loadUsers()
            toast.success(result.message)
            navigate('/profissional')
        } catch (error) {
            toast.error(error instanceof Error && error.message ? error.message : 'Erro ao desativar profissional!')
        } finally {
            handleClose()
        }
    }

    if (!open || !data) return null
    const canDeactivate = data.professional.id !== user?.userID

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Desativar profissional'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete={canDeactivate}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDeactivate)}>
                <div className='text-sm text-gray-800 dark:text-white/90'>
                    {canDeactivate ? (
                        <p>
                            Deseja desativar <strong className='text-error-400'>{data.professional.name}</strong> nesta
                            unidade? Negócios e notas serão preservados.
                        </p>
                    ) : (
                        <p>Você não pode desativar seu próprio acesso à unidade.</p>
                    )}
                </div>
            </form>
        </Modal>
    )
}

export default ProfessionalDeactivate
